export enum SupportProviderRatePeriod {
  monthly = "Monthly",
  hourly = "Hourly",
}
